import React, { useState } from "react";
import CommonModal from "../../../core/common/CommonModal";

const PrivacyRequests = () => {
  const [showPrivacyModal, setShowPrivacyModal] = useState(false);
  const [showPackageModal, setShowPackageModal] = useState(false);

  const [privacyModalType, setPrivacyModalType] = useState<
    | "background"
    | "copyReport"
    | "deleteReport"
    | "disputeReport"
    | "stopReport"
  >("background");

  const handlePrivacyModal = (
    type: "copyReport" | "deleteReport" | "disputeReport" | "stopReport",
  ) => {
    setPrivacyModalType(type);
    setShowPrivacyModal(true);
  };

  return (
    <>
      <div>
        <h6 className="fw-bold mb-3">Additional request on candidate:</h6>
        <p>
          For any of the below requests, please write to us at{" "}
          <span className="text-dander">candidatesupport@aupertz.co.in</span> to raise
          a ticket
        </p>
        {/* please use here login for modal in for logic */}
        <ul
          className="ps-3 mb-0"
          style={{ lineHeight: "1.9", listStyle: "circle" }}
        >
          <li
            className="text-primary"
            style={{ cursor: "pointer" }}
            onClick={() => handlePrivacyModal("copyReport")}
          >
            Obtain a copy of my report
          </li>

          <li
            className="text-primary"
            style={{ cursor: "pointer" }}
            onClick={() => handlePrivacyModal("deleteReport")}
          >
            Delete my data/report
          </li>

          <li
            className="text-primary"
            style={{ cursor: "pointer" }}
            onClick={() => handlePrivacyModal("disputeReport")}
          >
            Dispute my report
          </li>

          <li
            className="text-primary"
            style={{ cursor: "pointer" }}
            onClick={() => handlePrivacyModal("stopReport")}
          >
            Stop my report/Withdraw consent
          </li>
        </ul>
      </div>

      <CommonModal
        show={showPackageModal || showPrivacyModal}
        onClose={() => {
          setShowPackageModal(false);
          setShowPrivacyModal(false);
        }}
        modalType={showPackageModal ? "background" : privacyModalType}
      />
    </>
  );
};

export default PrivacyRequests;
